import type { RemoveAlertAction, ShowAlertAction } from './actions';
import { AlertActionNames } from './actionTypes';

import type { AlertConfig, AlertMessage, AlertTypes } from '../../components';

export const showAlertActionCreator = (
  alertType: AlertTypes,
  message: AlertMessage,
  alertConfig?: AlertConfig
): ShowAlertAction => ({
  type: AlertActionNames.SHOW_ALERT_ACTION,
  alertType,
  message,
  alertConfig,
  id: Date.now().toString(),
});

export const removeAlertAction = (id: string): RemoveAlertAction => ({
  type: AlertActionNames.REMOVE_ALERT_ACTION,
  id,
});
